import {Component, OnInit, Input, HostBinding, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';

import {RoutingService} from 'src/app/services/routing.service';
import { NoPermissionAction } from '../../directives/check-permissions.directive';
import SectionsAccess from '../../../permission/enums/sectionsAccess.enum';

@Component({
  selector: 'terra-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainNavComponent implements OnInit {
  // @HostBinding('attr.class') hostClasses = 'container';

  public covercyLogoSrc = '/assets/images/logo/logo.png';

  @Input()
  pageTitle: string = null;

  @Input()
  showNav = true;

  @Input()
  showAccountActions = true;

  NoPermissionAction = NoPermissionAction;
  SectionsAccess = SectionsAccess;

  constructor(private router: Router, public routingService: RoutingService) {
  }

  ngOnInit() {
  }

  forceReloadOnSamePage(relativePath: string) {
    if (relativePath === this.router.url) {
      window.location.reload();
      return false;
    }
  }
}
